import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register-user-success',
  templateUrl: './register-user-success.component.html',
  styleUrls: ['./register-user-success.component.scss']
})
export class RegisterUserSuccessComponent implements OnInit {

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor() { }

  ngOnInit(): void {
  }

}
